/**
 * Load Google API script (gapi).
 *
 * Shared by Google Drive picker flows across the app.
 * - Adds the script only once (via data attribute).
 * - Preserves CSP by applying a nonce from <meta property="csp-nonce"> when present.
 */
export async function loadGoogleApiScript(): Promise<void> {
  if (document.querySelector('script[data-google-api="true"]')) return
  await new Promise<void>((resolve, reject) => {
    const s = document.createElement("script")
    // Use a nonce if present to satisfy CSP and prevent injection
    const cspNonce = (
      document.querySelector(
        'meta[property="csp-nonce"]'
      ) as HTMLMetaElement | null
    )?.content
    if (cspNonce) s.nonce = cspNonce
    s.src = "https://apis.google.com/js/api.js"
    s.async = true
    s.defer = true
    s.crossOrigin = "anonymous"
    s.referrerPolicy = "no-referrer"
    s.setAttribute("data-google-api", "true")
    s.onload = () => resolve()
    s.onerror = () => reject(new Error("Failed to load Google API script"))
    document.head.appendChild(s)
  })
}
